import { Routes } from '@angular/router';
import { factFindSectionResolver } from '../features/fact-find/resolvers/fact-find-section.resolver';
import { applicationsResolver } from '../features/fact-find/resolvers/applications.resolver';
import { collectionSectionGuard } from '../features/fact-find/guards/collection-section.guard';
import { dashboardResolver } from '../dashboard/dashboard.resolver';

export const factFindRoutes: Routes = [
  {
    path: 'all',
    resolve: { dashboardData: dashboardResolver },
    loadComponent: () =>
      import('../features/fact-find/fact-find-all/fact-find-all.component').then(
        (m) => m.FactFindAllComponent
      ),
  },
  {
    path: ':taskName',
    resolve: { applications: applicationsResolver, sectionData: factFindSectionResolver },
    children: [
      {
        path: 'view-all-question',
        loadComponent: () =>
          import('../features/fact-find/view-all-question/view-all-question.component').then(
            (m) => m.ViewAllQuestionComponent
          ),
      },
      {
        path: ':entryId/view-all-question',
        loadComponent: () =>
          import('../features/fact-find/view-all-question/view-all-question.component').then(
            (m) => m.ViewAllQuestionComponent
          ),
      },
      {
        path: 'success',
        loadComponent: () =>
          import('../features/fact-find/fact-find-success/fact-find-success.component').then(
            (m) => m.FactFindSuccessComponent
          ),
      },
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('../features/fact-find/fact-find-collection/fact-find-collection.component').then(
            (m) => m.FactFindCollectionComponent
          ),
        canActivate: [collectionSectionGuard],
      },
      {
        path: ':entryId/:questionId',
        loadComponent: () =>
          import(
            '../features/fact-find/fact-find-question-container/fact-find-question-container.component'
          ).then((m) => m.FactFindQuestionContainerComponent),
      },
      {
        path: ':questionId',
        loadComponent: () =>
          import(
            '../features/fact-find/fact-find-question-container/fact-find-question-container.component'
          ).then((m) => m.FactFindQuestionContainerComponent),
      },
    ],
  },
];
